import {Component, OnDestroy, OnInit} from '@angular/core';
import {CodaltComponent} from '../codalt.component';
import {BreadcrumbComponent} from '../services/breadcrumb/breadcrumb.component';
import {saveAs} from 'file-saver';
import {PdfReportService} from '../services/pdf-report.service';
import {ReactiveFormsModule} from '@angular/forms';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'pdf-briefpapier',
    templateUrl: './pdf-briefpapier.component.html',
    styleUrls: ['./pdf-briefpapier.component.scss'],
    imports: [
        BreadcrumbComponent,
        ReactiveFormsModule
    ]
})
export class PdfBriefpapierComponent extends CodaltComponent implements OnInit, OnDestroy {

    constructor(private pdfReportService: PdfReportService, private titleService: Title) {
        super();
        this.titleService.setTitle(`Briefpapier ${this.environment.titleAppend}`);
    }

    ngOnInit() {

    }

    underlayPdf(file: File) {
        this.subscriptions.add(
            this.pdfReportService.postPdfUnderlay(file).subscribe({
                next: document => {
                    const sanitizedName = file.name.replace(/[^a-z0-9.]/gi, '_');
                    saveAs(document, sanitizedName);
                },
                error: () => {
                }
            })
        );
    }
}
